// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { rfqQuoteDetailsProposedDetailsGridStyles } from "@conklin/Overrides/Widgets/RfqQuoteDetails/RfqQuoteDetailsProposedDetailsGrid";
import { css } from "styled-components";

rfqQuoteDetailsProposedDetailsGridStyles.spinnerWrapper = {
    css: css`
        display: flex;
        justify-content: center;
        align-items: center;
        height: 300px;
        width: 100%;
    `,
};

rfqQuoteDetailsProposedDetailsGridStyles.footerWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: flex-end;
        margin-top: 20px;
        @media print {
            display: block;
            margin-top: 20px;
        }
    `,
};

rfqQuoteDetailsProposedDetailsGridStyles.countValueText = {
    variant: "h3",
};
